import { Link, Theme } from '@easeltv/client-sdk';
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { useApi } from '../../../hooks/useApi/useApi';
import { useAuth } from '../../../providers/AuthProvider/AuthProvider';
import DumbLinkAtom, { ThemeSectionT } from './LinkAtom.dumb';

/* ---------------------------------- Types --------------------------------- */

export interface LinkAtomI {
    /** object that makes up a link */
    data: Link;

    /** section of the Theme object from SDK */
    section: ThemeSectionT;

    /** optional callback, executed before the user is taken to link destination */
    callback?: () => void;

    cta?: boolean;
}

/* -------------------------------- Component ------------------------------- */

/**
 * LinkAtom
 *
 * @param data LinkAtomI
 * @returns JSX.Element
 */
const LinkAtom = ({ data, section, cta = false, callback }: LinkAtomI) => {
    const { env, tenant } = useApi();
    const theme: Theme = useContext(ThemeContext);

    const { logout } = useAuth();

    const logoutCallback = () => {
        logout();
        callback?.();
    };

    return (
        <DumbLinkAtom
            logoutCallback={logoutCallback}
            cta={cta}
            callback={callback}
            data={data}
            env={env}
            section={theme.sections[section]}
            tenant={tenant}
        />
    );
};

/* --------------------------------- Export --------------------------------- */

export default LinkAtom;
